import * as React from 'react';
import ReactSelect from 'react-select';
import { useFiltersContext } from '../../contexts/filters';

const Select = ({ options }) => {
	options = [{ label: `All`, value: '' }, ...options];

	const { selectedTax, selectTaxTerm } = useFiltersContext();
	const [value, setValue] = React.useState(options[0]);

	const prevValue = React.useRef(options[0].value);
	const handleOnChange = (option) => {
		if (prevValue.current !== option.value) {
			setValue(option);
			selectTaxTerm('postType', option.value);

			prevValue.current = option.value;
		}
	};

	// When filters are reset, set our value back to the first option.
	React.useEffect(() => {
		if (!Object.values(selectedTax).length) {
			setValue(options[0]);
		}
	}, [selectedTax]);

	return (
		<ReactSelect
			className="pfa-filter-select"
			classNamePrefix="pfa-filter-select"
			options={options}
			onChange={handleOnChange}
			value={value}
		/>
	);
};

Select.displayName = 'Select';

export default Select;
